import { Component, ViewEncapsulation } from '@angular/core';

import { AvatarBaseDirective } from './avatar-base';

@Component({
    selector: 'st-avatar[big]',
    styleUrls: ['./avatar.scss'],
    template: `
        <img
            *ngIf="shouldShowImage"
            width="32"
            height="32"
            [ngSrc]="imageUrl"
            (error)="onImageError()"
            (load)="imgLoaded()" />
        <div
            *ngIf="!shouldShowImage"
            class="st-avatar__initials">
            {{ initials }}
        </div>
        <ng-content select="[upload]" />
    `,
    host: {
        class: 'st-avatar',
    },
    // changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class AvatarBigComponent extends AvatarBaseDirective {}

@Component({
    selector: 'st-avatar[horizontal-big]:not([big])',
    styleUrls: ['./avatar.scss'],
    template: `
        <img
            *ngIf="shouldShowImage"
            width="32"
            height="32"
            [ngSrc]="imageUrl"
            (error)="onImageError()"
            (load)="imgLoaded()" />
        <div
            *ngIf="!shouldShowImage"
            class="st-avatar__initials">
            {{ initials }}
        </div>
        <div
            class="st-avatar__name"
            [matTooltip]="userName">
            {{ userName }}
        </div>
        <ng-content select="[upload]" />
    `,
    host: {
        class: 'st-avatar',
    },
    // changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class AvatarBigHorizontalNameComponent extends AvatarBaseDirective {}

@Component({
    selector: 'st-avatar[vertical-big]:not([big])',
    styleUrls: ['./avatar.scss'],
    template: `
        <img
            width="40"
            height="40"
            [ngSrc]="imageUrl" />
        <div
            class="st-avatar__name"
            [matTooltip]="userName">
            {{ userName }}
        </div>
        <ng-content select="[upload]" />
    `,
    host: {
        class: 'st-avatar',
    },
    // changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class AvatarBigVerticalNameComponent extends AvatarBaseDirective {}
